import React from "react";
import { createPortal } from "react-dom";
import { FiLogOut, FiX, FiShield } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";
import { signOut } from "firebase/auth";
import { clearStaff2FAVerified } from "../../services/authFlowService";
import { sessionService } from "../../services/sessionService";
import "./staffcss/logoutmodal.css";

const StaffLogoutModal = ({ isOpen, onClose, onBeforeLogout }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleConfirm = async () => {
    clearStaff2FAVerified();
    sessionStorage.setItem('logoutInProgress', 'true');
    try {
      // Run any pre-logout cleanup (e.g. setting peerStatus to Away)
      if (onBeforeLogout) {
        await onBeforeLogout();
      }

      // Delete the current session document directly before signing out.
      const currentUser = auth.currentUser;
      if (currentUser) {
        await sessionService.deleteCurrentSession(currentUser.uid);
      }
      sessionService.clearCurrentSession();

      await signOut(auth);
      localStorage.clear();
      sessionStorage.removeItem('freshLoginInProgress');
      navigate("/login", { replace: true });
    } catch (e) {
      console.log("Sign out error:", e);
      sessionService.clearCurrentSession();
      localStorage.clear();
      sessionStorage.removeItem('freshLoginInProgress');
      navigate("/login", { replace: true });
    } finally {
      setTimeout(() => sessionStorage.removeItem('logoutInProgress'), 1000);
    }
  };

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="logout-modal-card" onClick={(e) => e.stopPropagation()}>
        <button className="logout-modal-close" onClick={onClose}>
          <FiX />
        </button>

        <div className="logout-modal-icon-wrapper">
          <div className="logout-modal-icon-bg">
            <FiLogOut />
          </div>
        </div>

        <div className="logout-modal-content">
          <h2 className="logout-modal-title">Ready to leave?</h2>
          <p className="logout-modal-subtext">
            Your session will end and you'll be redirected to the login page. You can always come back later!
          </p>
        </div>

        <div className="logout-modal-actions">
          <button className="logout-modal-btn cancel" onClick={onClose}>
            <span className="btn-text">Stay logged in</span>
          </button>
          <button className="logout-modal-btn confirm" onClick={handleConfirm}>
            <span className="btn-text">Log out</span>
            <FiLogOut className="btn-icon" />
          </button>
        </div>

        <div className="logout-modal-footer">
          <div className="logout-modal-security-info">
            <FiShield className="security-icon" />
            <span>Your data is safely saved</span>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StaffLogoutModal;
